
  export const svgSrc = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path fill=\"#000\" fill-opacity=\".9\" fill-rule=\"evenodd\" stroke=\"none\" d=\"m16 15.293 4.646-4.646.708.707L16.707 16l4.647 4.646-.707.708L16 16.707l-4.646 4.647-.707-.707L15.293 16l-4.646-4.646.707-.707z\"/></svg>";
  export default svgSrc
  